import * as C from '../constants';
import { ELng, ESides } from '../enums';

const INITIAL_STATE = Object.freeze({
  errorData: [],
  lng: ELng.EN,
  [C.SET_MENU]: ESides.LEFT,
});

// eslint-disable-next-line
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case C.APP_DATA:
    case C.SET_ENGINE:
    case C.SET_BLADES:
    case C.SET_PAINT:
    case C.SET_COLORS:
    case C.SET_ROTATION:
    case C.SET_PROPELLER:
    case C.SET_PLATFORM:
    case C.SET_WINGLIGHT:
    case C.SET_WHEELS:
    case C.SET_MENU:
    // case C.SET_SELECTED_COLOR:
    case C.SET_SKY:
    case C.LABEL_DATA: {
      return {
        ...state,
        [action.type]: action.payload,
      };
    }
    // case C.SET_CHANGE_COLOR: {
    //   const currentColors = state[C.SET_COLORS];
    //   const { nr, color } = action.payload;

    //   const newColors = [...currentColors];
    //   newColors[nr] = { ...currentColors[nr], default: color };

    //   const currentSetColors: any = state[C.SET_SELECTED_COLOR];

    //   return {
    //     ...state,
    //     [C.SET_COLORS]: newColors,
    //     [C.SET_SELECTED_COLOR]: {
    //       nr: currentSetColors.nr,
    //       color,
    //     },
    //   };
    // }
    case C.SET_CURRENT_COLOR: {
      const { paletteNr, color } = action.payload;
      const currentColors = state[C.SET_COLORS];

      const newColors = [...currentColors];
      newColors[paletteNr] = { ...currentColors[paletteNr], default: color };

      return {
        ...state,
        [C.SET_COLORS]: newColors,
      };
    }
    case C.STORE_ERROR: {
      const existingErrors = state.errorData;
      const latestError = [action.payload];
      const errorData = [...existingErrors, ...latestError];

      return {
        ...state,
        errorData,
      };
    }
    case C.CLOSE_ERROR: {
      const existingErrors = state.errorData;
      // eslint-disable-next-line
      const removedError = existingErrors.shift();
      const errorData = [...existingErrors];

      return {
        ...state,
        errorData,
      };
    }
    default:
      return state;
  }
};
